module.exports = __webpack_public_path__ + "img/scope3category16.7f84e00f.svg";